import React , {useEffect, useState} from 'react';
import { useParams,Redirect } from 'react-router-dom';
import DatasetInfo from '../components/DatasetInfo';
import DatasetClasses from '../components/DatasetClasses';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';

import './ViewDataset.css';

const ViewDataset = () => {
      const [isLoading, setIsLoading] = useState(false);
      const [loadedDataset, setLoadedDataset]= useState();
      const [error, setError]= useState();
      const datasetId = useParams().datasetId;
     
      useEffect(()=>{
        window.scrollTo(0, 0);
        const sendRequest = async() =>{
          try{
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/datasets/'+datasetId);
            if (await !response.ok){
              setError(response.statusText);
            }else{
              const responseData= await response.json();
              setLoadedDataset(responseData);
              setIsLoading(false);
            }
          }catch(err){
            setError(err); 
          }
        };
        sendRequest();
      },[datasetId]);
     // const loadedDataset = DATASETS.filter(dataset => dataset.id === datasetId);

 return (  <div className="viewDatasetDiv">
      {error &&  <Redirect to="/" /> }
      {isLoading &&(<div className="center"><LoadingSpinner asOverlay/></div>)} 
      {!isLoading && loadedDataset &&<DatasetInfo
        key={loadedDataset.id}
        id={loadedDataset.id}
        image={`${process.env.REACT_APP_BACKEND_URL}/static/thumbnails/datasets/${loadedDataset.id}.jpg`}
        title={loadedDataset.title}
        description={loadedDataset.description}
        active={loadedDataset.active_now}
        url={loadedDataset.url}
        void={loadedDataset.void}
        numOfClasses={loadedDataset.classes}
        numOfEntities={loadedDataset.entities}
        numOfRecommendations={loadedDataset.recommendations}
        ontologies={loadedDataset.ontologies}
        />} 
      
       {!isLoading && loadedDataset && <DatasetClasses cs={loadedDataset.cs}/>}
</div>);
}

export default ViewDataset;